import { type ParsedLocation, redirect } from '@tanstack/react-router';

import type { RouterContext } from '~/router-context.ts';

interface RequireAuthenticatedBeforeLoadOptions {
	readonly context: RouterContext;
	readonly location: ParsedLocation;
}

function getRedirectTo(location: ParsedLocation): string {
	const hash = location.hash ? `#${location.hash}` : '';

	return location.pathname + location.searchStr + hash;
}

export function requireAuthenticatedBeforeLoad({ context, location }: RequireAuthenticatedBeforeLoadOptions): void {
	if (context.authSession?.accessToken) {
		return;
	}

	throw redirect({
		search: {
			redirectTo: getRedirectTo(location),
		},
		to: '/auth/signin',
	});
}
